import { render, staticRenderFns } from "./promotionAdd.vue?vue&type=template&id=1c67aa84&"
import script from "./promotionAdd.vue?vue&type=script&lang=js&"
export * from "./promotionAdd.vue?vue&type=script&lang=js&"
import style0 from "./promotionAdd.vue?vue&type=style&index=0&id=1c67aa84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports